<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header" (click)="expandOrCollapse()" [ngClass]="{'pointer': !editMode}">
        <panel-chevron [showBody]="isShowInfo"></panel-chevron>
        <h3>Return Settings</h3>
        <div class="float-end header-button-container" (click)="$event.stopPropagation()">
            @if (allowEdit && isShowInfo && !editMode) {
                <button class="ace-btn btn-text has-icon" (click)="setEditMode()">
                    <i class="fa fa-pencil"></i>
                </button>
            }
            @if (isShowInfo && editMode) {
                <button class="ace-btn btn-text has-icon" (click)="save()" [disabled]="!hasChanges">
                    <i class="fa fa-save"></i>
                </button>
            }
            @if (isShowInfo && editMode) {
                <button class="ace-btn btn-text has-icon" (click)="cancelEdit()">
                    <i class="fa fa-close"></i>
                </button>
            }
        </div>
    </div>
    @if (isShowInfo) {
        <div class="card-body">
            <ws-ace-loader [show]="loading" [marginBottom]="50" [hasOverlay]="false"></ws-ace-loader>
            <div [hidden]="loading">
                <div class="ws-section">
                    <div class="ws-section__header">
                        <h4 class="ws-section__header__title">Return Settings</h4>
                    </div>
                </div>
                <div>
                    <return-settings [entityId]="parcelId" [entityType]="ReturnSettingsEntityTypeEnum.Parcel"
                                     (onInitialized)="onReturnSettingsInitialized($event)"
                                     (changed)="onReturnSettingsChanged($event)"></return-settings>
                </div>
                <div class="ws-section">
                    <div class="ws-section__header">
                        <h4 class="ws-section__header__title">Reporting Parcel Sites</h4>
                    </div>
                </div>
                <div>
                    <reporting-parcel-site-list [siteId]="siteId" [parcelId]="parcelId"
                                                (onInitialized)="onReportingParcelSitesInitialized($event)"
                                                (changed)="onReportingParcelSitesChanged($event)"></reporting-parcel-site-list>
                </div>
            </div>
        </div>
    }
</div>
